import { Box } from '@mui/material'
import OptionHOC, { _getStars, getOptionLabel } from '@platform/react/hoc/autocomplete/option'
import OverflowTooltip from 'ui/Element/Text/OverflowTooltip'
import Icon from 'ui/Element/Icon'

/**
 * Displays a generic option for the {@link Autocomplete} menu with options for setting a `label`,
 * `subLabel`, `infoText`, `hasRanking` and `icon`.
 *
 * @param {Object} classes  styling for the option
 * @param {Object} props    props for the option
 *
 * @returns {*}
 */
const GenericOption = (classes, props = {}) => {
  const { option } = props

  return (
    <>
      <Box
        key={'item'}
        component={'div'}
        className={classes.option}
      >
        {!option.label ? null : (
          <Box
            key={'label'}
            component={'span'}
            className={classes.label}
          >
            {option.label}
          </Box>
        )}
        <OverflowTooltip>
          {getOptionLabel(option)}
        </OverflowTooltip>
        {!option.subLabel ? null : (
          <Box className={classes.label}>
            {option.subLabel}
          </Box>
        )}
      </Box>
      {!option.icon || option?.iconInOption === false ? null : (
        <Icon
          source={option.icon}
          name={'dot'}
          color={option.color || 'primary'}
        />
      )}
      {option.hasRanking
        ? _getStars(option.score)
        : null}
      {!option.infoText ? null : (
        <Box className={classes.label}>
          {option.infoText}
        </Box>
      )}
    </>
  )
}

export default OptionHOC(GenericOption)
